<div class="page-container">
  <h1>Verwalte dein Abo</h1>
  <div>
    <div class="widget">
      <h2 class="abo-title">Sparkly Premium</h2>
      <span>
        <ng-container *ngIf="currentSubscription?.paymentPeriod === 'year'">12-Monate Laufzeit</ng-container>
        <ng-container *ngIf="currentSubscription?.paymentPeriod === 'month'">1 Monat Laufzeit</ng-container>
        <ng-container *ngIf="currentSubscription?.isTrial">7 Tage Probezeitraum</ng-container>
      </span>
      <span>Enddatum: {{ currentSubscription?.currentPeriodEnd | date: 'dd.MM.yyyy' }}</span>
    </div>
    <p *ngIf="currentSubscription && !currentSubscription.canceledAt" class="info-small">Dein Abo wird am Enddatum automatisch verlängert.</p>
    <p *ngIf="currentSubscription && currentSubscription.canceledAt && !currentSubscription.isTrial" class="info-important">Du hast das Abo am {{currentSubscription.canceledAt | date: 'dd.MM.yyyy'}} gekündigt.</p>
  </div>
  <app-button *ngIf="currentSubscription && !currentSubscription.canceledAt" [text]="'Abo kündigen'" [color]="'error'" [style]="'outlined'" (clickEvent)="unsubscribeAbo()"></app-button>
</div>
